module.exports = __webpack_public_path__ + "static/media/historical-marker-both.39cc6484.svg";